module.exports = __webpack_public_path__ + "static/img/7.76ef2e3b.png";